var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"py-0"},[_c('v-row',[_c('v-img',{staticClass:"img-width",attrs:{"src":_vm.getImgUrl(_vm.path),"max-height":_vm.height}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }